module.exports = __webpack_public_path__ + "img/app_sub_active.8e399a8a.svg";